/**
 * Words and phrases every area uses. Only what is truly generic belongs
 * here; a label whose meaning depends on its screen goes in that screen's
 * namespace, even when the English happens to match.
 */
export default {
    actions: {
        add: 'Add',
        apply: 'Apply',
        back: 'Back',
        cancel: 'Cancel',
        close: 'Close',
        copy: 'Copy',
        create: 'Create',
        delete: 'Delete',
        discard: 'Discard',
        download: 'Download',
        edit: 'Edit',
        import: 'Import',
        next: 'Next',
        previous: 'Previous',
        refresh: 'Refresh',
        remove: 'Remove',
        save: 'Save',
        search: 'Search',
        upload: 'Upload',
        view: 'View',
    },
    state: {
        loading: 'Loading…',
        saving: 'Saving…',
        deleting: 'Deleting…',
        uploading: 'Uploading…',
        saved: 'Saved',
        active: 'Active',
        inactive: 'Inactive',
        on: 'On',
        off: 'Off',
        draft: 'Draft',
        published: 'Published',
        unsaved: 'Unsaved changes',
    },
    fields: {
        name: 'Name',
        title: 'Title',
        description: 'Description',
        email: 'Email',
        phone: 'Phone',
        status: 'Status',
        type: 'Type',
        code: 'Code',
        slug: 'Slug',
        url: 'URL',
        language: 'Language',
        created: 'Created',
        updated: 'Updated',
        price: 'Price',
        amount: 'Amount',
        total: 'Total',
        country: 'Country',
        image: 'Image',
        actions: 'Actions',
    },
    words: {
        yes: 'Yes',
        none: 'None',
        default: 'Default',
        from: 'From',
        to: 'To',
        or: 'or',
    },
    messages: {
        fixErrors: 'Fix the highlighted fields and save again.',
    },
    count: {
        selected: '{n} selected',
    },
};
